export default __webpack_public_path__ + "static/media/Palash.0485a9db.jpg";